import React from 'react'
import { Grid, Modal, Button, Heading } from '@enterprise-ui/canvas-ui-react'
import { Link } from 'react-router-dom'
import '../../Cases/Custom.css'

import { useGlobalForm } from '../Context/GlobalFormStateContext'
import { SET_FIELD } from './Constants'

interface MainProp {
  heading: String
  headingText: String
}

const CancelModal: React.FC<MainProp> = ({ headingText, heading }) => {
  const [state, dispatch] = useGlobalForm()
  return (
    <div>
      <Modal
        headingText={headingText}
        isVisible={state.isCancel}
        onRefuse={() => {
          dispatch({
            type: SET_FIELD,
            payload: [{ id: 'isCancel', value: false }],
          })
        }}
      >
        <div className="hc-pa-normal">
          <Grid.Container>
            <Grid.Item xs>
              <Heading size={6}>{heading}</Heading>
            </Grid.Item>
          </Grid.Container>
          <Grid.Container direction="row-reverse" spacing="dense">
            <Grid.Item>
              <Button type="primary" as={Link} to={'/cases'}>
                Yes
              </Button>
            </Grid.Item>
            <Grid.Item>
              <Button
                type="secondary"
                onClick={() => {
                  dispatch({
                    type: SET_FIELD,
                    payload: [{ id: 'isCancel', value: false }],
                  })
                }}
              >
                No
              </Button>
            </Grid.Item>
          </Grid.Container>
        </div>
      </Modal>
    </div>
  )
}

export default CancelModal
